import React from 'react';

const FormBox = ({ children }) => (
  <div className="session">
    <div style={{backgroundColor: 'white'}} className="main-content">
      <form name="form_resetpassword" className="login-form">
        {children}
      </form>
    </div>
  </div>
);

export default FormBox;



// WEBPACK FOOTER //
// ./src/components/common/form/formBox.js